import { Directive, EventEmitter, HostListener, Input, OnDestroy, Output } from "@angular/core";

@Directive({
  standalone: true,
  selector: '[longPress]',
})
export class LongPressDirective implements OnDestroy {
  @Input() longPressThreshold = 3000;
  @Output() longPress: EventEmitter<boolean> = new EventEmitter();

  private timeout: NodeJS.Timeout;
  
  ngOnDestroy(): void {
    this.stop();
  }

  @HostListener('mousedown', ['$event'])
  @HostListener('touchstart', ['$event'])
  onMouseDown(_downEvent: MouseEvent | TouchEvent) {
    this.stop();
    this.timeout = setTimeout(() => {
      this.longPress.emit(true);
    }, this.longPressThreshold);
  }

  @HostListener('mouseup', ['$event'])
  @HostListener('touchend', ['$event'])
  onMouseUp(_upEvent: MouseEvent | TouchEvent) {
    this.stop();
  }
  
  private stop() {
    clearTimeout(this.timeout);
  }
}